import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { FooterSection } from '@components'
import './WorkCareer.scss'
import { CareerAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { TitleComponent } from '../../../common/components/TitleComponent'
import { useParams } from 'react-router-dom'
import { ThumbnailBig } from '../../../common/components'
import MenuCareer from '../MenuCareer'

const Container = styled.div`
  padding-top: 72px;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const WorkCareerContainer = styled.div`
  margin-top: 56px;
  padding: 24px 119px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
    padding: 24px 30px;
  }
`

const Img = styled.img`
  width: 100%;
  height: 550px;
  object-fit: cover;
  margin: 0px auto;
  @media (max-width: 768px) {
    height: 300px;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const WorkCareer = function () {
  const { t } = useTranslation()
  const [data, setdata] = useState([])
  const [shortDesc, setShortDesc] = useState({})
  const [isLoading, setisLoading] = useState(true)

  const { id } = useParams()

  useEffect(() => {
    setisLoading(true)
    loadData()
  }, [])

  const loadData = async function () {
    const { data } = await CareerAPI('bekerja')
    setdata(data.data)
    setisLoading(false)
  }
  return (
    <div>
      <TitleComponent title={isLoading ? '' : shortDesc.title} />
      <Container>
        <Desktop>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerBekerja}
            desc={isLoading ? '' : data.deskripsiBannerBekerja}
            img={isLoading ? '' : data.imageBannerDesktopBekerja}
          />
        </Desktop>
        <Mobile>
          <ThumbnailBig
            title={isLoading ? '' : data.judulBannerBekerja}
            desc={isLoading ? '' : data.deskripsiBannerBekerja}
            img={isLoading ? '' : data.imageBannerMobileBekerja}
          />
        </Mobile>
      </Container>

      <WorkCareerContainer className="container-fluid">
        <div className="m-0 row">
          <div className="p-0 col-lg-9 col-12">
            {data.deskripsiDataBekerja !== 'undefined' &&
              data.deskripsiDataBekerja !== '' && (
                <div className="row">
                  <div className="col-12 mb-4">
                    <Desktop>
                      <Img src={data.imageDataDesktopBekerja} />
                    </Desktop>
                    <Mobile>
                      <Img src={data.imageDataMobileBekerja} />
                    </Mobile>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: data.deskripsiDataBekerja,
                      }}
                    ></div>
                  </div>
                </div>
              )}
          </div>
          <div className="d-none d-lg-block col">
            <MenuCareer active={0} />
          </div>
        </div>
      </WorkCareerContainer>
      <FooterSection currentPage={t('life_at_bukopin')} />
    </div>
  )
}

export default WorkCareer
